import React, { useEffect, useState } from "react";
import ShowToast from "components/ShowToast";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";

// Mirrors Flutter `_addNewBankAccount()`:
// POST payout_action_manager { action: "ADD", user_id, bankname, account, name, ifsccode }
//
// Bank list -> GET soft_bank_list (SoftMintAPI.Softmintbank_list), reads bank_details.csv
// and returns { data: [{ bankId, name, iin, ifsc, ... }] }
const AddWalletBankAccountModal = ({ show, onClose, onSuccess }) => {
  const { userid } = useSession();

  const [bankList, setBankList] = useState([]);
  const [bankListLoading, setBankListLoading] = useState(false);

  const [bankname, setBankname] = useState("");
  const [account, setAccount] = useState("");
  const [name, setName] = useState("");
  const [ifsccode, setIfsccode] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      fetchBankList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const fetchBankList = async () => {
    setBankListLoading(true);
    try {
      const res = await fetchWrapper("https://pro.mokshiq.in/soft_bank_list");
      setBankList(res?.data || []);
    } catch (e) {
      ShowToast("Failed to load bank list", "danger");
    } finally {
      setBankListLoading(false);
    }
  };

  if (!show) return null;

  const resetForm = () => {
    setBankname("");
    setAccount("");
    setName("");
    setIfsccode("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!bankname || !account || !name || !ifsccode) {
      ShowToast("Please fill all the fields", "danger");
      return;
    }

    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("action", "ADD");
      formData.append("user_id", userid);
      formData.append("bankname", bankname);
      formData.append("account", account);
      formData.append("name", name);
      formData.append("ifsccode", ifsccode);

      const res = await fetchWrapper("https://pro.mokshiq.in/payout_action_manager", {
        method: "POST",
        body: formData,
      });

      if (res?.status === true) {
        ShowToast(res.data || "Account Added Successfully", "success");
        resetForm();
        onSuccess && onSuccess();
        onClose();
      } else {
        ShowToast(res?.data || "Something went wrong", "danger");
      }
    } catch (e) {
      ShowToast("Failed to add bank account", "danger");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-box">
        <div className="modal-header-custom">
          <h5>Add Settlement Bank Account</h5>
          <button className="close-btn" onClick={onClose} disabled={submitting}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Bank Name</label>
            <select
              className="form-control"
              value={bankname}
              onChange={(e) => setBankname(e.target.value)}
              disabled={bankListLoading}
            >
              <option value="">
                {bankListLoading ? "Loading banks..." : "Select Bank"}
              </option>
              {bankList.map((bank) => (
                <option key={bank.bankId} value={bank.name}>
                  {bank.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Account Holder Name</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Account Holder Name"
            />
          </div>

          <div className="form-group">
            <label>Account Number</label>
            <input
              type="text"
              className="form-control"
              value={account}
              onChange={(e) => setAccount(e.target.value)}
              placeholder="Enter Account Number"
            />
          </div>

          <div className="form-group">
            <label>IFSC Code</label>
            <input
              type="text"
              className="form-control"
              value={ifsccode}
              onChange={(e) => setIfsccode(e.target.value.toUpperCase())}
              placeholder="Enter IFSC Code"
            />
          </div>

          <div className="modal-footer-custom">
            <button type="button" className="btn secondary" onClick={onClose} disabled={submitting}>
              Close
            </button>
            <button type="submit" className="btn primary" disabled={submitting}>
              {submitting ? "Saving..." : "Add Account"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddWalletBankAccountModal;